

















































































import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})

export default class ProfileRatingStar extends Vue {
  @Prop({ type: Number })
  public techniqueRating !: number;

  @Prop({ type: Number })
  public communicationRating !: number;

  @Prop({ type: Number })
  public understandingRating !: number;

  @Prop({ type: Number})
  public starSize !: number;

  private get averageRate(): number {
    return Number(((this.techniqueRating + this.communicationRating + this.understandingRating) / 3).toFixed(1))
  }
}
